'use client';

import { useEffect, useState } from 'react';

/**
 * Observes a container element and returns its content height.
 * Returns 0 until the ref is set and the observer has run.
 */
export function useContainerHeight(containerRef: React.RefObject<HTMLElement | null>, mounted: boolean): number {
  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const ro = new ResizeObserver(entries => {
      const entry = entries[0];
      if (entry) setContainerHeight(entry.contentRect.height);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [containerRef, mounted]);

  return containerHeight;
}
